import React from 'react';
import { connect } from 'react-redux';
import WordChooseBtn from './WordChooseBtn';
import { charSelected } from '../../../actions/char';
import { wordSelected } from '../../../actions/word';
import { genCharArray } from '../../../utils/utils';

export class WordChoose extends React.Component {
	constructor(props) {
	    super(props);

	    this.state = {
	    	words: {
	    		'a': ['after', 'am', 'and', 'are', 'at', 'ate'], 
	    		'b': ['because', 'big', 'birthday', 'bought', 'brother', 'but'], 
	    		'c': ['called', 'came', 'can', 'car', 'cat', 'could'], 
	    		'd': ['dad', 'day', 'did', 'didnt', 'do', 'dog'], 
	    		'e': ['each', 'eat', 'ever', 'every', 'everyone'], 
	    		'f': ['fish', 'football', 'for', 'friends', 'from', 'fun'], 
	    		'g': ['gave', 'get', 'go', 'going', 'good', 'got'], 
	    		'h': ['had', 'he', 'her', 'his', 'home', 'house'], 
	    		'i': ['if', 'in', 'inside', 'into', 'is', 'it'], 
	    		'j': [['jet', true], 'jump', ['jumped', true], ['jumper', true], ['jumps', true], 'just'], 
	    		'k': [['keep', true], 'kind', ['kite', true], ['kitten', true], 'know'], 
	    		'l': ['like', 'liked', 'little', 'lived', 'lots', 'love'], 
	    		'm': ['made', 'man', 'me', 'morning', 'mum', 'my'], 
	    		'n': ['name', 'named', 'next', 'night', 'no', 'not'], 
	    		'o': ['of', 'on', 'once', 'one', 'our', 'out'], 
	    		'p': ['park', 'party', 'people', 'play', 'played', 'put'], 
	    		'q': ['queen', ['quick', true], ['quiet', true]], 
	    		'r': ['rabbit', 'ran', 'really', 'red', 'ride', 'room'], 
	    		's': ['said', 'saw', 'she', 'so', 'some', 'sunday'], 
	    		't': ['the', 'then', 'there', 'they', 'time', 'to'], 
	    		'u': ['under', 'until', 'up', 'upon', 'us'], 
	    		'v': ['very'], 
	    		'w': ['was', 'we', 'went', 'were', 'when', 'with'], 
	    		'x': ['next', ['exit', true], ['fix', true], ['six', true]], 
	    		'y': [['yellow', true], 'yes', 'yesterday', ['yet', true], 'you', 'your'], 
	    		'z': [['zebra', true], ['zip', true], ['zoo', true]]
	    	}
	    };
  	}
  	filterTypes = (obj, accepted) => {
	    var result = {};
	    for (var type in obj) {
	        if (accepted.indexOf(type) > -1) {
	            result[type] = obj[type];
	        }
	    }
	    return result[accepted];
	}
    onClick = (e) => {
    	this.props.wordSelected(e.target.id);
	}
	componentWillReceiveProps(nextProps) {
        if (nextProps.char !== this.state.char) {
            this.state.char = nextProps.char;
			this.state.array = this.filterTypes(this.state.words, [this.state.char]);
			this.props.wordSelected(undefined);
			this.state.word = undefined;
        }
        if (nextProps.word) {
        	this.state.word = nextProps.word;
        }
    }
	componentWillUnmount() {
		this.props.wordSelected(undefined);
	}
    render() {
        return (
            <div id="word-choose" className="panel">
		        <div className="title"></div>
		        <div className="panel-arrow-r"></div>
		        <div className="holder">
		            <div className="holder-inner">
		            	{this.state.array && this.state.array.map((label, index) => {
		                    return (
		                    	<WordChooseBtn word={label[0]} selected={typeof(label) === 'string' ? this.state.word === label : this.state.word === label[0]} key={index} label={typeof(label) === 'string' ? label : label[0]} asterisk={typeof(label) === 'object' ? ' asterisk' : ''} onClick={this.onClick} />
		                    );
		                })}
		            </div>
		        </div>
		    </div>
        );
    }
};

const mapStateToProps = (state) => ({
	char: state.char.char,
	word: state.word.word
})

const mapDispatchToProps = (dispatch) => ({
	wordSelected: (word) => dispatch(wordSelected(word))
});

export default connect(mapStateToProps, mapDispatchToProps)(WordChoose);



// WEBPACK FOOTER //
// ./src/components/sections/words/WordChoose.js